import { alpha, Chip } from "@mui/material";

import { ChipLabel } from "@/components/elements/chip-label";

interface ActionableDisclosureChipProps {
  actionableDisclosuresCount: number;
}

export function ActionableDisclosuresChip({ actionableDisclosuresCount }: ActionableDisclosureChipProps) {
  return (
    <Chip
      variant="outlined"
      label={
        <ChipLabel
          name="Disclosures not started"
          count={actionableDisclosuresCount}
          sx={{ bgcolor: (theme) => theme.palette.orange.main }}
        />
      }
      size="small"
      sx={{
        borderRadius: 1,
        color: (theme) => theme.palette.orange.main,
        bgcolor: (theme) => alpha(theme.palette.orange.main, 0.08),
        border: "none",
        maxWidth: 200,
      }}
    />
  );
}
